import React, { useState, useEffect, useCallback } from "react";
import { Row, Col, Button } from "react-bootstrap";
import ReceiptTemplate from "../InvoiceComp/ReceiptTemplate";
import pdfMake from "pdfmake/build/pdfmake.js";
import ReceiptTemplate_MSA from "../InvoiceComp/ReceiptTemplate_MSA";
import moment from "moment-timezone";
import GYAxios from "../../../util/GYAxios";

const ReceiptModel = (props) => {
	const [receipt, setReceipt] = useState(null);
	const [PDFDoc, setPDFDoc] = useState(null);
	const resetPreview = props.resetPreview;
	const initForm = props.initForm;
	const btnContainerStyle = { textAlign: "center" };

	const receiptNo = props.selectedReceipt.receipt.receiptNo;
	const isMSA = props.selectedReceipt.invoice.operation_status === 2;
	const [isMSAReceipt, setIsMSAReceipt] = useState(isMSA);
	const [loaded, setLoaded] = useState(false);

	/**
	 * Download PDF document
	 * @returns PDF document
	 */
	const downloadPDF = () =>
		pdfMake.createPdf(PDFDoc).download(`${receiptNo}.pdf`);

	const checkBillChanged = useCallback(async (data) => {
		const invoiceData = !Array.isArray(data?.invoice)
			? data?.invoice
			: data?.invoice[0];
		const receiptData = data?.receipt;

		if (invoiceData == null || receiptData == null) return;

		let isBillChanged = false;

		const paymentDate = moment(receiptData?.paymentDate).format("YYYYMMDD");
		const refInv = invoiceData.additional_info;
		const table_bill = invoiceData.table_name;

		if (refInv != null && refInv != "") {
			const obj_info = JSON.parse(refInv);
			if (obj_info.invoice != null) {
				isBillChanged = obj_info.invoice.billing_changed;
			}
		}

		if (isBillChanged) {
			const uriBill = `/receipts/billing_details/${table_bill}/${paymentDate}`;
			await GYAxios.get(uriBill)
				.catch((err) => {
					console.log(err);
				})
				.then((res) => {
					if (!Array.isArray(data.invoice)) {
						data.invoice.billing_address = res.data[0]?.billing_address;
						data.invoice.billing_name = res.data[0]?.billing_name;
					} else {
						data.invoice[0].billing_address = res.data[0]?.billing_address;
						data.invoice[0].billing_name = res.data[0]?.billing_name;
					}

					setReceipt(data);
					setLoaded(true);
				});
		} else {
			setReceipt(data);
			setLoaded(true);
		}
	}, []);

	useEffect(() => {
		checkBillChanged(props.selectedReceipt);
	}, [props.selectedReceipt]);

	return (
		<div>
			{/* Header */}
			<Row>
				<Col md="10">
					<h5>{receiptNo}</h5>
				</Col>
				<Col md="2">
					<span
						className="glyphicon glyphicon-chevron-right"
						id="close-preview"
						onClick={resetPreview}
					></span>
				</Col>
			</Row>

			{/* Receipt preview */}
			<Row>
				{isMSAReceipt && loaded && receipt ? (
					<ReceiptTemplate_MSA receipt={receipt} setPDFDoc={setPDFDoc} />
				) : (
					<ReceiptTemplate receipt={receipt} setPDFDoc={setPDFDoc} />
				)}
			</Row>

			{/* Buttons container */}
			<Row style={btnContainerStyle}>
				<Button
					variant="warning"
					className="receipt-preview-btn"
					onClick={() => {
						initForm({ data: receipt });
						props.setIsEdit(true);
					}}
				>
					Edit
				</Button>
				<Button
					variant="primary"
					className="receipt-preview-btn"
					onClick={downloadPDF}
				>
					Download
				</Button>
			</Row>
		</div>
	);
};

export default ReceiptModel;
